import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { AllInsights } from '@leagueplatform/dashboard';
import { StackLayout } from '@leagueplatform/genesis-core';
import { CONTENT_MAX_WIDTH } from '@leagueplatform/web-common-components';

export const MetricsPage = () => {
  usePageViewAnalytics({ screen_name: 'Metrics' });
  const { formatMessage } = useIntl();
  useDocumentTitle(formatMessage({ id: 'STR_METRICS' }));

  return (
    <StackLayout
      orientation="vertical"
      verticalAlignment="center"
      horizontalAlignment="stretch"
      css={{
        marginX: 'auto',
        padding: '$none $two',
        maxWidth: CONTENT_MAX_WIDTH,
        '@mobile': {
          padding: '$none $one',
        },
      }}
    >
      <AllInsights />
    </StackLayout>
  );
};
